function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2816 7.5H8.59406C7.99026 7.5 7.5 7.99026 7.5 8.59406V11.4066C7.5 12.0094 7.99026 12.5006 8.59406 12.5006H13.2816C13.8844 12.5006 14.3756 12.0103 14.3756 11.4066V8.59406C14.3747 7.99026 13.8844 7.5 13.2816 7.5Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2816 13.7503H8.59406C7.99026 13.7503 7.5 14.2406 7.5 14.8434V21.4059C7.5 22.0097 7.99026 22.5 8.59406 22.5H13.2816C13.8844 22.5 14.3756 22.0097 14.3756 21.4059V14.8434C14.3747 14.2406 13.8844 13.7503 13.2816 13.7503Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4059 17.5003H16.7184C16.1156 17.5003 15.6244 17.9906 15.6244 18.5944V21.4069C15.6244 22.0097 16.1147 22.5009 16.7184 22.5009H21.4059C22.0097 22.5 22.5 22.0097 22.5 21.4059V18.5934C22.5 17.9906 22.0097 17.5003 21.4059 17.5003Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4059 7.5H16.7184C16.1156 7.5 15.6244 7.99026 15.6244 8.59406V15.1566C15.6244 15.7594 16.1147 16.2506 16.7184 16.2506H21.4059C22.0088 16.2506 22.5 15.7603 22.5 15.1566V8.59406C22.5 7.99026 22.0097 7.5 21.4059 7.5Z"
});

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b8bcfe8a.svg";
export { ForwardRef as ReactComponent };